const contactData = {
  email: "taliajob2@gmail.com",
  phone: "0556724279",
  github: "https://github.com/taliachoen",
};

export default contactData;